'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { cn } from '@/libs';
import { useDrawerStore } from '@/stores';
import { ROUTES } from '@/types/enums';

import { menuNavigation } from './utils/common';

import { usePolicyDrawer } from '../PolicyDrawer';
import { IconDynamic, Separator } from '../ui';

export const MenuNavigation = () => {
  const router = useRouter();
  const onCloseForce = useDrawerStore((state) => state.forceCloseDrawerWithPreventClear);
  const { openPolicyDrawer } = usePolicyDrawer();

  const handleItemClick = (item: (typeof menuNavigation)[0]) => {
    if (item.id === 'my-wallet') {
      onCloseForce();
      // Marcar como navegação interna para evitar bloqueio automático
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('internal-navigation-carteira', 'true');
      }
      router.push(ROUTES.Enum['/carteira']);
    } else if (item.id === 'help') {
      onCloseForce();
      openPolicyDrawer();
    } else {
      onCloseForce();
    }
  };

  return (
    <div data-cy="menu-navigation" className="flex flex-col gap-y-2 p-2">
      {menuNavigation.map((item) => (
        <div key={item.id}>
          {item.id === 'my-wallet' || item.id === 'help' ? (
            <button
              data-cy={`menu-navigation-${item.id}-button`}
              onClick={() => handleItemClick(item)}
              className="w-full h-12 flex gap-x-3 items-center p-3 bg-background-variant rounded-lg hover:bg-background-variant transition-colors"
            >
              {IconDynamic(item.icon, { width: 24, height: 24 })}
              <span className="uppercase font-semibold text-sm text-foreground">
                {item.label}
              </span>
            </button>
          ) : (
            <Link
              data-cy={`menu-navigation-${item.id}-link`}
              href={item.href}
              onClick={onCloseForce}
              className={cn(
                'h-12 flex gap-x-3 items-center p-3 bg-background-variant rounded-lg',
                // item.id === 'my-tickets'
                //   ? 'bg-secondary hover:bg-secondary/90 text-secondary-foreground'
                //   : '',
              )}
            >
              {IconDynamic(item.icon, { width: 24, height: 24 })}
              <span
                className={cn(
                  'uppercase font-semibold text-sm text-foreground',
                  // item.id === 'my-tickets' ? 'text-secondary-foreground' : '',
                )}
              >
                {item.label}
              </span>
            </Link>
          )}
          {/*{item.id === 'my-tickets' && <Separator className="mt-2 mb-1" />}*/}
          {item.id === 'last-results' && <Separator className="mt-2 mb-1" />}
        </div>
      ))}
    </div>
  );
};
